import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import OrderPayment from "../components/shopPartials/OrderPayment";
import { useCart } from "../components/contexts/CartContext";
import { useGeneral } from "../components/contexts/GeneralContext";
import CartSummary from "../components/shopPartials/CartSummary";
import {
  useChildDetails,
  useDate,
  useDisclaimer,
  useKid,
  useMealsSelection,
  useMealType,
  usePayment,
  useStep,
} from "../components/contexts/SubscriptionContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MealPayment from "../components/planPartials/MealPayment";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import { useEffect, useState } from "react";
import PaymentUpdated from "../components/planPartials/PaymentUpdated";
import GeneralButton from "../components/common/GeneralButton";
import { TiChevronLeft, TiChevronRight } from "react-icons/ti";
import Modal from "../components/common/Modal";

const PaymentPage = () => {
  const { type } = useParams();
  const { discountCoupons } = useGeneral();
  const { cart, fetchCart } = useCart();
  const navigate = useNavigate();
  const { fetchCards, savedCards } = usePayment();
  const { goToStep } = useStep();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const renew = params.get("renew");
  const { setSelectedMealType } = useMealType();
  const { clearMeals } = useMealsSelection();
  const { clearChildDetails } = useChildDetails();
  const { resetDisclaimer } = useDisclaimer();
  const { setSelectedKidId } = useKid();
  const { setSelectedDate } = useDate();
  const [showSessionExpired, setShowSessionExpired] = useState(false); // NEW

  const isMealSessionExpired = () => {
    const sessionStarted = localStorage.getItem("sessionStarted");
    if (!sessionStarted) return false; // no marker, nothing to expire

    const elapsedMs = Date.now() - new Date(sessionStarted).getTime();
    return elapsedMs > 24 *60 * 60 * 1000;
  };
  const isRenewSessionExpired = () => {
    const sessionStarted = localStorage.getItem("renewSessionStarted");
    if (!sessionStarted) return false; // no session marker, nothing to expire

    const elapsedMs = Date.now() - new Date(sessionStarted).getTime();
    return elapsedMs > 24 *60 * 60 * 1000;
  };
  const clearLocalStorage = () => {
    localStorage.removeItem("selectedPlanNew");
    localStorage.removeItem("selectedMealTypeNew");
    localStorage.removeItem("selectedChildNew");
    localStorage.removeItem("selectedMealsNew");
    localStorage.removeItem("childDetailsNew");
    localStorage.removeItem("acceptedDisclaimerNew");
    localStorage.removeItem("subscriptionStartDate");
    localStorage.removeItem("selectedDateNew");
    localStorage.removeItem("promoCodeSaved");
    localStorage.removeItem("selectedCity");
    localStorage.removeItem("mealCartId");
    setSelectedMealType(null);
    setSelectedDate(null);
    setSelectedKidId(null);
    clearMeals();
    clearChildDetails();
    resetDisclaimer();
  };
  const handleGoBack = () => {
    if (renew !== "true" && isMealSessionExpired()) {
      setShowSessionExpired(true);
      return;
    } else if (renew === "true" && isRenewSessionExpired()) {
      setShowSessionExpired(true);
      return;
    }

    navigate(-1);
  };
  const handleMealPayNow = () => {
    if (renew !== "true" && isMealSessionExpired()) {
      setShowSessionExpired(true);
      clearLocalStorage();
      return;
    } else if (renew === "true" && isRenewSessionExpired()) {
      setShowSessionExpired(true);
      return;
    }

    if (renew === "true") {
      navigate("/meals-payment-processor?renew=true");
    } else {
      navigate("/meals-payment-processor");
    }
  };
  useEffect(() => {
    goToStep("5");
    fetchCart();
  }, []);
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="">
        <Header code={discountCoupons} />
        <BodyWrapper className="mb-4 lg:mb-0">
          {type === "meals" && renew != "true" && (
            <TopStepsStatus url={""} rightText="" />
          )}
          <p
            className={`text-34pt pb-4 md:pb-6 2.5xl:pb-9  ${
              renew != "true"
                ? "mt-4 md:mt-6 2.5xl:mt-9"
                : "pb-4 md:pb-6 2.5xl:pb-8"
            }`}
          >
            Payment Summary
          </p>

          <div
            className={`grid grid-cols-1 2xl:grid-cols-[2fr_0.9fr] 
             `}
          >
            {/* ${
              savedCards.length > 0
                ? "2xl:grid-cols-[4fr_0.9fr] 2.5xl:grid-cols-[3fr_0.9fr]"
                : "2xl:grid-cols-[1fr_0.9fr]"
            }  */}
            {type === "order" ? (
              <div className="w-full xl:w-[90%] ">
                <div
                  className={`bg-[#DEE2DD]/40 rounded-[15px] w-full   p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[70px]`}
                >
                  <CartSummary cart={cart?.orderCart} hidePromo={true} />
                  {/* <OrderPayment /> */}
                </div>
                <div className="flex items-end justify-between mt-9">
                  <GeneralButton
                    onClick={() => navigate(-1)}
                    text="Prev step"
                    title=""
                    iconPosition="Left"
                    bgColor="#ccc"
                    textColor="#000"
                    icon={<TiChevronLeft size={24} className="me-4" />}
                    className="text-24pt"
                  />
                  <GeneralButton
                    onClick={() => navigate("/order-payment-processor")}
                    text="Pay Now"
                    title=""
                    type="button"
                    bgColor="#30160E"
                    textColor="#ccc"
                    icon={<TiChevronRight size={24} className="ms-4" />}
                    className="text-24pt"
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="w-full xl:w-[90%] ">
                  <div
                    className={`bg-[#DEE2DD]/40 rounded-[15px] w-full   p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[70px]`}
                  >
                    <CartSummary cart={cart?.mealCart} hidePromo={true} />
                    {/* <OrderPayment /> */}
                  </div>
                  <div className="flex items-end justify-between mt-9">
                    <GeneralButton
                      onClick={handleGoBack}
                      text="Prev step"
                      title=""
                      iconPosition="Left"
                      bgColor="#ccc"
                      textColor="#000"
                      icon={<TiChevronLeft size={24} className="me-4" />}
                      className="text-24pt"
                    />
                    <GeneralButton
                      onClick={handleMealPayNow}
                      text="Pay Now"
                      title=""
                      type="button"
                      bgColor="#30160E"
                      textColor="#ccc"
                      icon={<TiChevronRight size={24} className="ms-4" />}
                      className="text-24pt"
                    />
                  </div>
                </div>
                {/* <div className="">
                <PaymentUpdated />
              </div> */}
              </>
            )}
          </div>
          <Modal
            isOpen={showSessionExpired}
            onClose={() => setShowSessionExpired(false)}
            title="Session Expired"
            onConfirm={() => {
              setShowSessionExpired(false);

              if (renew === "true") {
                localStorage.removeItem("renewSessionStarted");
              } else {
                localStorage.removeItem("sessionStarted");
              }
              navigate(renew === "true" ? "/account" : "/plans"); // adjust to your actual start-of-flow route
            }}
            confirmButton="Start Again"
            dismissible={false}
            showCancel={false}
          >
            <div className="font-mono">
              <p>
                Your session is no longer active. Please start the process
                again.
              </p>
            </div>
          </Modal>
        </BodyWrapper>

        <Footer />
      </PageWrapper>
    </>
  );
};

export default PaymentPage;
